import { Button, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from "@material-ui/core";
import React, { useMemo, useState } from "react";
import { ChatAvatar } from "../../../../digitalArena/modules/ChatModule/components/ChatAvatar";
import { combineProps, deepClone } from "../../../../helpers/objectHelper";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import VideocamIcon from "@material-ui/icons/Videocam";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { formatTime, datesAreOnSameDay } from "../../../../helpers/time.helper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { VideoCallButton } from "../../../shared/VideoCallButton";
import { LinkedInButton } from "../../../shared/LinkedInButton";
import { ChatSearchbar } from "../../../../digitalArena/modules/ChatModule/components/ChatSearchbar";
import { uuidv4 } from "../../../../helpers/securityHelper";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import PhoneMissedIcon from "@material-ui/icons/PhoneMissed";

export const ConversationList = (props) => {
  const [filter, setFilter] = useState("");

  const { orderList = [], exhibitorId, connectionList = [], exhibitorsHosts = [], chatConnections = [], clientKey, logList = [], chat, selectChat, nonAvailablePersons, videoRequest } = props;

  const messagesRead = (seen, sender, messages) => {
    return (!seen && sender != clientKey) || !seen || messages.find((m) => m.seen == false && m.sender != clientKey);
  };

  const activeConversations = orderList
    .filter((o) => {
      const exist = o.badgeNo != clientKey && chat.find((c) => c.target == o.badgeNo);

      if (!filter && exist) return true;
      if (o.name.toLowerCase().includes(filter.toLowerCase()) && exist) {
        return true;
      }

      if (o.company && o.company.toLowerCase().includes(filter.toLowerCase()) && exist) {
        return true;
      }

      if (o.title && o.title.toLowerCase().includes(filter.toLowerCase()) && exist) {
        return true;
      }
    })
    .map((v, i) => {
      const isHost = orderList.find((e) => e.badgeNo == v.badgeNo && e.exhibitorId == exhibitorId);
      const conversation = chat.find((c) => c.target == v.badgeNo);

      const lastMessage = conversation.messages[conversation.messages.length - 1].message;
      const lastSender = conversation.messages[conversation.messages.length - 1].sender;
      const lastSenderName = lastSender == clientKey ? <SystemLabel name="You" /> : "";

      const undreadMessages = conversation.messages.filter((c) => c.receiver == clientKey && c.seen == false).length;

      const read = undreadMessages == 0;
      const online = connectionList.find((c) => c.clientKey == v.badgeNo);
      const inAnotherRoom = chatConnections.find((cc) => cc.clientKey == v.badgeNo);
      const called = logList.find((l) => l.value == v.badgeNo);
      return (
        <div key={uuidv4()}>
          <ListItem>
            <ListItemAvatar>
              <>
                {isHost ? <VerifiedUserIcon className="expo-admin-icon" /> : null}
                <ChatAvatar
                  {...combineProps([
                    props,
                    {
                      connectionList,
                      orderList,
                      primaryColor: "#e4e6eb",
                      secondaryColor: "#fff",
                      target: v.badgeNo,
                    },
                  ])}
                ></ChatAvatar>
              </>
            </ListItemAvatar>

            <ListItemText
              primary={
                <div style={{ display: "flex", maxWidth: 500 }}>
                  <span style={{ fontWeight: "600", fontSize: "1rem" }}>{v.name}</span>
                  {!read ? <div className="notice-dot-expo-new">{undreadMessages}</div> : null}
                </div>
              }
              secondary={
                <span
                  style={{
                    fontSize: "1rem",
                  }}
                >
                  {lastMessage?.substring(0, 20)} • {formatTime(conversation.lastChange)} <br />
                  {called && datesAreOnSameDay(new Date(called.inserted), new Date()) ? (
                    <>
                      <span className="phone-missed">
                        <PhoneMissedIcon />
                        <EventLabel2 name="Missed" groupName="Exhibitor.Admin" /> •{` ${formatTime(called.inserted, null, "")}`}
                      </span>
                      <br />
                    </>
                  ) : null}
                  {!online && inAnotherRoom ? (
                    <span className="in-another-room">
                      <EventLabel2 name="ActiveInAnotherRoom" groupName="Exhibitor.Admin" />
                    </span>
                  ) : null}
                </span>
              }
            />
            <ListItemSecondaryAction>
              <LinkedInButton tooltipTitle={<EventLabel2 name="VisitLinkedInProfile" groupName="Exhibitor.Admin" />} {...v} />
              <IconButton onClick={() => selectChat(v.badgeNo)}>
                <Tooltip title={<EventLabel2 name="Chat" groupName="Exhibitor.Admin" />}>
                  <ChatBubbleIcon />
                </Tooltip>
              </IconButton>
              <VideoCallButton tooltipTitle={<EventLabel2 name="StartVideoMeeting" groupName="Exhibitor.Admin" />} {...combineProps([props, { badgeNo: v.badgeNo }])} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider variant="inset" component="li" />
        </div>
      );
    });

  const visitorsOnline = orderList
    .filter((o) => {
      const online = o.badgeNo != clientKey && connectionList.find((c) => c.clientKey == o.badgeNo) && !chat.find((c) => c.target == o.badgeNo);

      if (o.name.toLowerCase().includes(filter.toLowerCase()) && connectionList.find((c) => c.clientKey == o.badgeNo) && online) {
        return true;
      }

      if (o.company && o.company.toLowerCase().includes(filter.toLowerCase()) && connectionList.find((c) => c.clientKey == o.badgeNo) && online) {
        return true;
      }

      if (o.title && o.title.toLowerCase().includes(filter.toLowerCase()) && connectionList.find((c) => c.clientKey == o.badgeNo) && online) {
        return true;
      }
    })
    .map((v, i) => {
      const isHost = orderList.find((e) => e.badgeNo == v.badgeNo && e.exhibitorId == exhibitorId);

      return (
        <div key={uuidv4()}>
          <ListItem>
            <ListItemAvatar>
              {isHost ? <VerifiedUserIcon className="expo-admin-icon" /> : null}
              <ChatAvatar
                {...combineProps([
                  props,
                  {
                    connectionList,
                    orderList,
                    primaryColor: "#e4e6eb",
                    secondaryColor: "#fff",
                    target: v.badgeNo,
                  },
                ])}
              ></ChatAvatar>
            </ListItemAvatar>
            <ListItemText primary={<span style={{ fontWeight: "600", fontSize: "1rem" }}>{v.name}</span>} secondary={v.company} />
            <ListItemSecondaryAction>
              <LinkedInButton tooltipTitle={<EventLabel2 name="VisitLinkedInProfile" groupName="Exhibitor.Admin" />} {...v} />
              <IconButton onClick={() => selectChat(v.badgeNo)}>
                <Tooltip title={<EventLabel2 name="Chat" groupName="Exhibitor.Admin" />}>
                  <ChatBubbleIcon />
                </Tooltip>
              </IconButton>
              <VideoCallButton tooltipTitle={<EventLabel2 name="StartVideoMeeting" groupName="Exhibitor.Admin" />} {...combineProps([props, { badgeNo: v.badgeNo }])} />
            </ListItemSecondaryAction>
          </ListItem>
          <Divider variant="inset" component="li" />
        </div>
      );
    });

  return (
    <div className="conversation-list" style={{ paddingTop: 15 }}>
      <span className={"expo-title"} style={{ margin: "10px 5px" }}>
        <EventLabel2 name="ChatWithVisitors" groupName="Exhibitor.Admin" />
      </span>

      <div style={{ margin: 10 }}>
        <ChatSearchbar filter={setFilter} />
      </div>
      <List>
        {/*     <Typography className="expo-title" color="textSecondary" gutterBottom>
          <EventLabel2 name="MyConversations" groupName="Exhibitor.Admin" />
        </Typography> */}
        {activeConversations}
        {/*   <Typography color="textSecondary" gutterBottom className="expo-title">
          <EventLabel2 name="PeopleOnline" groupName="Exhibitor.Admin" />
        </Typography> */}
        {visitorsOnline}
      </List>
    </div>
  );
};
